export default "__VITE_ASSET__CJbk$cGv__"